import { Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/material";

export interface Logoprop {
  disabledLink?: boolean;
  sx?: [];
}

const Logo: React.FC<Logoprop> = (props) => {
  const logo = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        src="/static/images/ratebotai_logo.png"
        sx={{ width: "40px" }}
      />

      <Box
        component="img"
        src="/static/images/ratebotai_logo_white.png"
        sx={{ width: "160px" }}
      />
    </Box>
  );

  if (props.disabledLink) {
    return <>{logo}</>;
  }
  // return <RouterLink to="/">{logo}</RouterLink>;
  return <>{logo}</>;
};

export default Logo;
